export interface Chart {
  backgroundColor: string;
  chart: any;
  chartKeys: string[];
  class: string;
  colors: ChartColor[];
  gradientColors: Gradient[];
  height: number;
  highlights: Highlight[];
  id: string;
  labels: string[];
  maxValue: number;
  minValue: number;
  noOfResults: number;
  normValueBars: number[];
  purposeName: string;
  rawHtmlHeader: boolean;
  stepSize: number;
  subTitle: string;
  tickLabels: Record<number, string>;
  title: string;
  type: number;
  xAxeTitle: string;
  yAxeTitle: string;
}

export interface ChartColor {
  backgroundColor: string | null;
  borderColor: string | null;
  fill: boolean;
  hoverBackgroundColor: string | null;
  pointBackgroundColor: string | null;
  pointBorderColor: string | null;
}

export interface Gradient {
  gradientColors: GradientColor[];
}

export interface GradientColor {
  color: string;
  value: number;
}

export interface Highlight {
  title: string;
  begin: number;
  end: number;
  fillStyleColor: string;
  borderWidth: number;
  borderColor: string;
  dottedLine: boolean;
  linkedLabel: string;
}

export interface LineChart extends Chart {
  showLegend: boolean;
  series: string[];
  stacked: boolean;
  showChartTooltip: boolean;
  xLabelInfo: boolean;
  purposeOnXLabel: boolean;
  extraInfoLabels: string[];
  purposeLabels: string[];
  purposes: string[];
  blankOnLoad: boolean;
}

export interface HorizontalBarChart extends Chart {
  isSeriesColors: boolean;
  series: string[];
  purposes: string[];
  purposeKeys: Record<string, string>;
}

export interface PieChart extends Chart {
  isSeriesColors: boolean;
  series: string[];
  showLegend: boolean;
  showChartTooltip: boolean;
}
export enum ChartType {
  Old,
  BarChart,
  LineChart,
  PerformedByLineChart,
  HorizontalBarChart,
  PieChart
}
